import validator from 'validator';

export const validatePassword = (password: string): boolean => {
  const valid = validator.isStrongPassword(password, {
    minLength: 8,
    minNumbers: 1,
    minSymbols: 1,
    minUppercase: 1,
    minLowercase: 1,
  });
  return valid;
};

export const validatePasswordMessage = `Your password must contain:
- At least 8 characters
- At least one lowercase letter (a-z)
- At least one lowercase letter (A-Z)
- At least one number (0-9)
- At least one special character`;
